// Marketing-attribution consent gate. Stores `librario.consent.marketing = 'granted'|'denied'`
// plus a version-stamped meta key in localStorage.
// marketingConsentGranted() fails safe (→ false); writes report failure to the caller.
const CONSENT_KEY = 'librario.consent.marketing'
const META_KEY = 'librario.consent.marketing.meta'

// Policy version the current disclosure copy corresponds to. Bump when the
// Datenschutz "Anzeigen-Attribution" section materially changes → re-prompt.
export const POLICY_VERSION = '2026-06-28'

export function marketingConsentGranted() {
  return marketingConsentDecision() === 'granted' && decisionIsCurrent()
}

export function marketingConsentDecision() {
  try {
    const value = localStorage.getItem(CONSENT_KEY)
    return value === 'granted' || value === 'denied' ? value : null
  } catch {
    return null
  }
}

export function decisionIsCurrent() {
  try {
    const meta = JSON.parse(localStorage.getItem(META_KEY) || '{}')
    return meta.version === POLICY_VERSION
  } catch {
    return false
  }
}

// Records the user's own decision. Returns false if persistence threw (Safari
// private mode) so the caller can reportError — the user took an explicit action
// expecting it to stick.
export function recordMarketingConsent(granted) {
  try {
    localStorage.setItem(CONSENT_KEY, granted ? 'granted' : 'denied')
    localStorage.setItem(
      META_KEY,
      JSON.stringify({ ts: new Date().toISOString(), version: POLICY_VERSION }),
    )
    return true
  } catch {
    return false
  }
}
